import { motion } from 'framer-motion';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useGetBookQuery, usePostBookMutation, useUpdatePostMutation } from '../features/books/bookAPISlice';


const initialBook = {
    name: "",
    author: "",
    thumbnail: "",
    price: 0,
    rating: 0,
    featured: false
}

const AddBook = () => {
    const {pathname} =useLocation();
    const {bookId}=useParams()
    
    const {data,isLoading,error}=useGetBookQuery(bookId,{
        skip: !bookId,
      })
    const [postBook,{isLoading:postLoading,data:postData,error:postError}]=usePostBookMutation()
    const [updateBook,{isLoading:updateLoading,data:updateData,error:updateError}]=useUpdatePostMutation()



    const [bookInputs, setbookInputs] = useState(initialBook);


 

    const inputHandler = (event) => {
        const { name, type, value } = event.target;
        setbookInputs({ ...bookInputs, [name]: type == "checkbox" ? event.target.checked ? true : false : value })


    }

    const naviagte =useNavigate()

    const submitForm = (e) => {
        e.preventDefault();

        if (bookInputs?.id) {
            updateBook(bookInputs)
            
        } else {
            postBook(bookInputs)

        }

        setbookInputs(initialBook);
        naviagte('/')
       
    }


    useEffect(() => {
        if(bookId && data){
           

            setbookInputs(data)
        }
    }, [data,bookId])
    



    return (
        <>


            <motion.div transition={{duration:2}}  className="p-8 overflow-hidden bg-white shadow-cardShadow rounded-md max-w-xl mx-auto">
                <h4 className="mb-8 text-xl font-bold text-center">{pathname.includes('/edit-book') ? 'Edit ' : 'Add New'} Book </h4>
                <form className="book-form" onSubmit={submitForm}>
                    <div className="space-y-2">
                        <label htmlFor="lws-bookName">Book Name</label>
                        <input  value={bookInputs?.name}  onChange={inputHandler} required className="text-input" type="text" id="lws-bookName" name="name" />
                    </div>
                    <div className="space-y-2">
                        <label htmlFor="lws-author">Author</label>
                        <input  value={bookInputs?.author}  onChange={inputHandler} required className="text-input" type="text" id="lws-author" name="author" />
                    </div>
                    <div className="space-y-2">
                        <label htmlFor="lws-thumbnail">Image Url</label>
                        <input  value={bookInputs?.thumbnail}  onChange={inputHandler} required className="text-input" type="text" id="lws-thumbnail" name="thumbnail" />
                    </div>
                    <div className="grid grid-cols-2 gap-8 pb-4">
                        <div className="space-y-2">
                            <label htmlFor="lws-price">Price</label>
                            <input  value={bookInputs?.price}  onChange={inputHandler} required className="text-input" type="number" id="lws-price" name="price" />
                        </div>
                        <div className="space-y-2">
                            <label htmlFor="lws-rating">Rating</label>
                            <input  value={bookInputs?.rating}  onChange={inputHandler} required className="text-input" type="number" id="lws-rating" name="rating" min={1} max={5} />
                        </div>
                    </div>
                    <div className="flex items-center">
                        <input  value={bookInputs?.featured} checked={bookInputs?.featured}  onChange={inputHandler} id="lws-featured" type="checkbox" name="featured" className="w-4 h-4" />
                        <label htmlFor="lws-featured" className="ml-2 text-sm"> This is a featured book </label>
                    </div>
                    <button type="submit" className="submit" id="lws-submit" disabled={!Object.values({...bookInputs,featured:true}).every(Boolean)}>Add Book</button>
                </form>
            </motion.div>



        </>
    )
}

export default AddBook